﻿import React from 'react';
import { Tooltip as BPTooltip, Position } from "@blueprintjs/core";
import PropTypes from 'prop-types';

import 'components/tooltip/Tooltip.css';

export function Tooltip(
    {
        position = "auto",
        minimal = false,
        disabled = false,
        usePortal = true,
        children,
        content
    }
) {

    let direction;
    switch (position.toLowerCase()) {
        case "top":
            direction = Position.TOP;
            break;
        case "bottom":
            direction = Position.BOTTOM;
            break;
        case "left":
            direction = Position.LEFT;
            break;
        case "right":
            direction = Position.RIGHT;
            break;
        default:
            direction = "auto";
            break;
    }

    return (
        <BPTooltip content={content} placement={direction} minimal={minimal} disabled={disabled} usePortal={usePortal}>
            <>
                {children}
            </>
        </BPTooltip>
    );

}

Tooltip.propTypes = {
    children: PropTypes.element,
    content: PropTypes.any.isRequired,
    position: PropTypes.string,
    minimal: PropTypes.bool,
    disabled: PropTypes.bool,
    usePortal: PropTypes.bool
};
